import * as React from "react";
import { House, Building2, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const solutions = [{
  title: "درمان اضطراب و افسردگی",
  description: "ارائه راهکارهای علمی و حمایتی برای مدیریت هیجانات و بازیابی آرامش درونی در مواجهه با چالش‌های زندگی.",
  icon: House,
  link: "/SpecializedAreasPage"
}, {
  title: "روان‌شناسی میگرن و دردهای مزمن",
  description: "تخصص ویژه در مدیریت روان‌شناختی دردهای مزمن و میگرن با تمرکز بر کاهش تنش‌های عصبی و بهبود کیفیت زندگی.",
  icon: Building2,
  link: "/SpecializedAreasPage"
}, {
  title: "مشاوره کودک و نوجوان",
  description: "بهبود روابط والد-فرزندی و حل چالش‌های رفتاری و تحصیلی با رویکردهای نوین روان‌شناسی رشد.",
  icon: Sparkles,
  link: "/SpecializedAreasPage"
}];
export default function TailoredShineSolutions() {
  return <section data-section-id="222836" id="چگونه-میتوانم-به-شما-کمک-کنم" className="w-full py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center mb-16">
          <h1 className="text-3xl md:text-5xl font-default font-bold tracking-tight text-foreground">
            چگونه می‌توانم به شما کمک کنم؟
          </h1>
          <p className="max-w-[700px] text-muted-foreground font-default text-xl">
            خدمات تخصصی روان‌شناختی با بیش از ۱۰ سال تجربه بالینی برای همراهی شما در مسیر سلامت روان و آرامش.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full flex flex-col bg-card border-t-4 border-t-primary border-x-border border-b-border shadow-md transition-all duration-300 hover:scale-105 hover:shadow-lg rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-accent flex items-center justify-center mb-4 text-primary">
                      <Icon className="w-6 h-6 stroke-[1.5]" />
                    </div>
                    <CardTitle className="text-2xl font-default text-card-foreground">
                      {solution.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="text-lg font-default text-muted-foreground leading-relaxed">
                      {solution.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-4">
                    <Button variant="ghost" className="w-full justify-between group text-secondary hover:text-primary-foreground hover:bg-primary rounded-lg" asChild>
                      <Link to={solution.link}>
                        <span className="font-default font-medium">مشاهده جزئیات</span>
                        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}